import { MetadataKeysTable } from '@/components/MetadataKeys/MetadataKeysTable';
import { useGetCurrentUser } from '@/hooks/api/users/useGetCurrentUser';
import { usePageTitle } from '@/hooks/usePageTitle';
import { createUseStyles } from '@/services/createUseStyles';
import { Box } from '@mui/material';

const contentMaxWidth = '750px';

const useStyles = createUseStyles({
  Users_root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: '100%',
    gap: '16px',
    overflowY: 'auto',
    padding: '24px',
  },
  Users_header: {
    marginBottom: '24px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  Users_content: {
    flexGrow: 1,
    overflowY: 'auto',
  },
});

export const MetadataPage = () => {
  const c = useStyles();
  const { permissions } = useGetCurrentUser();

  usePageTitle('Metadata Fields');

  return (
    <Box className={c.Users_root}>
      {permissions.canManageMetadataFields && (
        <Box sx={{ width: '100%', maxWidth: contentMaxWidth }}>
          <MetadataKeysTable />
        </Box>
      )}
    </Box>
  );
};
